<script setup lang="ts">
import { getActiveAccount } from '@/plugins/auth/msalConfig'
import SettingsEvents from '@/views/apps/centre-admin/settings/SettingsEvents.vue'
import SettingsInfo, { CentreDetails } from '@/views/apps/centre-admin/settings/SettingsInfo.vue'
import SettingsUsersManagement from '@/views/apps/centre-admin/settings/SettingsUsersManagement.vue'
import { OptimizedUser } from '@/views/apps/centre-admin/types'

// DAY-37: only for users whose roles allow it (same permission the API checks)
definePage({
  meta: {
    action: 'read',
    subject: 'Centers',
  },
})
const activeAccount = getActiveAccount()

const tabsData = [
  { icon: 'bx-info-circle', title: 'Centre Information' },
  { icon: 'bx-calendar', title: 'Centre Schedule' },
  { icon: 'bx-user', title: 'Users Management' },
  { icon: 'mdi-gavel', title: 'Legal and Regulatory' },
  { icon: 'bx-money', title: 'Accounting / Insurance' },
  { icon: 'bx-bookmark', title: 'Resources' },
  { icon: 'bx-file', title: 'Document Templates' },
  { icon: 'bx-food-tag', title: 'Nutrition' },
]

const { error } = useSnackbar()

const activeTab = ref(null)

const { data: curentUser } = await useApi<OptimizedUser>('/Users/GetCurrentUser')
const { data: centreDetailsData, error: centreDetailsError } = await useApi<CentreDetails>(`/Center/GetById/${curentUser.value?.centerId}`)

if (centreDetailsError.value) {
  error(`Error fetching centre details: ${centreDetailsError.value}`)
}

const centreDetails = ref<CentreDetails | null>(centreDetailsData.value || null)
</script>

<template>
  <VRow>
    <VCol cols="12" md="3">
      <VTabs v-model="activeTab" direction="vertical" class="v-tabs-pill disable-tab-transition">
        <VTab v-for="(tabItem, index) in tabsData" :key="index" :prepend-icon="tabItem.icon">
          <I18nT :keypath="tabItem.title" />
        </VTab>
      </VTabs>
    </VCol>

    <VCol cols="12" md="9">
      <VWindow v-model="activeTab" class="disable-tab-transition" :touch="false">
        <VWindowItem>
          <SettingsInfo :details="centreDetails" />
        </VWindowItem>

        <VWindowItem>
          <SettingsEvents />
        </VWindowItem>

        <VWindowItem>
          <SettingsUsersManagement :center-id="centreDetails?.id" />
        </VWindowItem>

        <VWindowItem>
          <div class="my-class">Legal and Regulatory (Coming soon)</div>
        </VWindowItem>
        <VWindowItem>
          <div class="my-class">Accounting / Insurance (Coming soon)</div>
        </VWindowItem>
        <VWindowItem>
          <div class="my-class">Resources (Coming soon)</div>
        </VWindowItem>
        <VWindowItem>
          <div class="my-class">Document Templates (Coming soon)</div>
        </VWindowItem>
        <VWindowItem>
          <div class="my-class">Nutrition (Coming soon)</div>
        </VWindowItem>
      </VWindow>
    </VCol>
  </VRow>
</template>

<style lang="scss">
.my-class {
  padding: 1.25rem;
  border-radius: 0.375rem;
  background-color: rgba(var(--v-theme-on-surface), var(--v-hover-opacity));
}
</style>
